const theme = {
  primaryOne: '#090909',
  primaryTwo: '#FFFFFF',
  primaryThree: '#CCCCCC',
  primaryHover: '#808080',
  button: '#1ECD97',
  mobile: '768px',
};

export default theme;
